<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            督办单号：<span v-if="formData.handleNo"
                           style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.handleNo }}</span>




          </div>
          <div style="display:none;">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">处理
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <div class="fr">
            <el-button v-if="formData.handleStat===1&&handleSJ" type="primary" plain class="button-sty" @click="handle" icon="el-icon-edit-outline">处理</el-button>
            <el-button v-if="!dataId&&handleSave" type="primary" class="button-sty" icon="el-icon-check" @click="saveData" >保存</el-button>
          </div>
        </div>



          <!-- 基本信息 -->
          <div style="overflow-y: scroll!important;
    height: 100vh!important; ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>督办信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      服务工单号
                    </th>
                    <td>
                      <el-input type="text"
                                autocomplete="off"
                                v-model="formData.orderNo"
                                clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showOrderPop=true"></i>
                      </el-input>
                    </td>
                     <th>
                      <em class="f-red">*</em>
                  督办对象
                    </th>
                    <td>
                      <el-input type="text"
                                autocomplete="off"
                                v-model="formData.handlerName"
                                clearable :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showSitePopType(1)"></i>
                      </el-input>
                    </td>
                    <th>
                   督办时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.handleTime" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00" @change="validateTime(1)">
                      </el-date-picker>
                    </td>
                  </tr>
                <tr>
                  <th>
                      <em class="f-red">*</em>
                      督办事项
                    </th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.handleMatter" placeholder="" @change="updateHandleMatterName">
                          <el-option v-for="item in sysDictItemList" :key="item.value" :label="item.label"
                                     :value="item.value"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      督办事由
                    </th>
                    <td colspan="5">
                      <el-input type="text" autocomplete="off" v-model="formData.handleRemark" style="width:  ;"
                                clearable/>
                    </td>
                </tr>
                <tr>
                      <th>创建人</th>
                      <td>{{ formData.createBy }}</td>
                      <th>创建时间</th>
                      <td>{{ formData.createTime }}</td>

                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="dataId" class="d-item" style="display: inline-block;height: 160px;width: 100%;">
                <div class="title first"><b>处理信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      督办状态
                    </th>
                    <td colspan="5">
                      <el-radio v-model="formData.changeHandleStat" :label="3">已处理</el-radio>
                      <el-radio v-model="formData.changeHandleStat" :label="5">无法处理</el-radio>
                      <el-radio v-model="formData.changeHandleStat" :label="9">关闭</el-radio>
                    </td>
                  </tr>
                    <tr>
                    <th>
                      处理时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.replyTime" :disabled="true" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00" format="yyyy-MM-dd HH:mm:ss" @change="validateTime(2)">
                      </el-date-picker>
                    </td>
                    <th>
                回复人名称
                    </th>
                    <td>
                      <el-input type="text"
                                autocomplete="off"
                                v-model="formData.replyerName"
                                clearable :disabled="true">
                        <i v-if="!stat1" slot="suffix" class="el-input__icon el-icon-search"
                           @click="showSitePopType(2)"></i>
                      </el-input>
                    </td>
                  </tr>
              <tr><th>
                      回复内容
                    </th>
                    <td colspan="5">
                      <el-input type="text" autocomplete="off" :disabled="formData.handleStat!=1" v-model="formData.replyRemark" clearable/>
                    </td></tr>
                    <tr>
                    </tr>
                  </tbody>
                </table>
              </div>



              <div v-if="dataId"  class="d-item" style="position: relative; height: 160px;">
                <div class="title first">
                  <b>附件信息</b>
                  <el-upload style="display:flex; margin-top: -6px; float: right"
                             class="upload-demo"
                             ref="upload"
                             :action="api.uploadFileUrl"
                             accept=".docx,.doc,.txt,.pdf,.xlsx"
                             :limit="3"
                             v-if="fileList.length < 5"
                             :show-file-list="false"
                             :on-success="(res,file, fileList) => {handleFileSuccess(res,file, fileList)}"
                             :headers="headers"
                             :auto-upload="true"
                             :on-preview="Previewf"
                  >
                    <el-button type="primary" class="button-sty btn_zdy2">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div class="current-info">
                  <vxe-table ref="filterTable" height="100"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow
                             :data="fileList"
                  >
                    <!--                <vxe-column type="checkbox" width="40"/>-->
                    <vxe-column field="name" title="附件名称" width="420"/>
                    <vxe-column title="操作" width="60">
                      <template #default="{row}">
                        <div @click="deleteFile(row)">
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>



              <div style="height:0px"></div>
            </div>
          </div>




      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

    <duDialog :param="this.type" v-if="showSitePop"
             @commitAdminRow="commitAdminRow"
             :visiable.sync="showSitePop"
             multi="true"/>
    <orderPop v-if="showOrderPop"
              @commit="orderCommit"
              :visiable.sync="showOrderPop"
              :siteId="formData.siteId"
              :isHandle="0"
              multi="true"/>



  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import duDialog from "@/views/dialogCommon/adminDialog";
import {dictType, loadDictData} from "@/config/dictType";
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import {mapGetters} from "vuex";
// import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'


export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    showSaveBtn: Boolean
  },
  components: {duDialog,orderPop},
  data() {
    return {
      fileList: [],
      stat1: false,
      type:null,
      showSitePop: false,
      showOrderPop: false,
      showWarehousePop: false,
      orgOptions: [],
      orgValue: '',
      areaOption: [],
      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      shippingMethodList: [],
      logisticsCompaniesList: [],
      formData: {
        id:null, //督办单ID
        orderNo: null,  // 服务工单号
        orderId: null, //服务工单ID
        handleNo: null,  // 督办单单号
        handleId: null, //督办人ID
        handlerName:null,//督办人名称
        handleTime:null,//督办时间
        handleMatter:null,// 回复人ID
        handleMatterName:null,//回复人名称
        handleRemark:null,//督办事由
        handleStat:null,//督办状态
        replyTime:null,// 处理时间
        replyerId:null,//处理人ID
        replyerName:null,//处理人名称
        replyRemark:null,//回复内容
        changeHandleStat:null,//处理信息选择的状态
        fileUrl1:null,
        fileUrl2:null,
        fileUrl3:null,
        fileList: [],
      },
      finSubjectList: [],
      sysDictItemList:[],

      show3: false,
      node: true,
      srcList: [],
      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    this.handleSave = this.permissions["handleSave"];
    this.handleSJ = this.permissions["handle"];
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.getData()
    this.changeStat()
    this.loadOrgData()
    this.loadFinSubject()
    this.loadDictData()
  },

  methods: {
    Previewf(file) {
      console.log(file);
      window.open(file.url, "_blank");

      // window.open(file.response)
      if (file) {
        const addTypeArray = file.name.split(".");
        const addType = addTypeArray[addTypeArray.length - 1];
        console.log(addType);
        if (addType === "pdf") {
          let routeData = this.$router.resolve({
            path: "/insurancePdf",
            query: { url: file.response, showBack: false },
          });
          window.open(routeData.href, "_blank");
        }
        //".rar, .zip, .doc, .docx, .xls, .txt, .pdf, .jpg,  .png, .jpeg,"
        else if (addType === "doc" || addType === "docx" || addType === "xls") {
          window.open(
            "http://view.officeapps.live.com/op/view.aspx?src=" + file.response
          );
        } else if (addType === "txt") {
          window.open(file.response);
        } else if (["png", "jpg", "jpeg"].includes(addType)) {
          window.open(file.response);
        } else if (addType === "rar" || addType === "zip") {
          this.$message({
            message: "该文件类型暂不支持预览",
            type: "warning",
          });
           return false;
        }
      }
    },

    validateTime(type){
      var selectedDate = "";
      if(type==1) {
        selectedDate = new Date(this.formData.handleTime); // 将选择的日期转换为Date对象
        const currentTime = new Date(); // 当前时间
        if (selectedDate < currentTime) {
          this.formData.handleTime = '';
          this.$message.error('选择的时间不能早于当前时间');
        }
      }else {
        selectedDate = new Date(this.formData.replyTime);
      }
      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedDate.getDate()).padStart(2, '0');
      const hours = String(selectedDate.getHours()).padStart(2, '0');
      const minutes = String(selectedDate.getMinutes()).padStart(2, '0');
      const seconds = String(selectedDate.getSeconds()).padStart(2, '0');
      const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      if(type==1) {
        this.formData.handleTime = formattedTime;
      }else {
        this.formData.replyTime = formattedTime;
      }
    },

    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      this.fileList.push({
        name: fileName,
        url: url
      })
    },

    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.fileList = this.fileList.filter(item => item.url !== row.url)
      })
    },

    // 回复内容附件的   使用
    changeStat(val){
      // if(val==1){
      //   this.stat1=false
      // }else{
      //   this.stat1=true
      // }
    },
    loadFinSubject() {
      this.$http({
        url: api.basFinSubject.getListDataUrl,
        method: 'post',
        data: {usable: 1}
      }).then(res => {
        this.finSubjectList = res.data.data
      })
    },

    //确定选择督办人
    commitAdminRow(data,type) {
      if(type==1) {
        this.formData.handlerId = data.id;
        this.formData.handlerName = data.username;
      }else {
        this.formData.replyerId = data.id;
        this.formData.replyerName = data.username;
      }
    },

    // 加载机构数据
    loadOrgData() {
      this.$http({
        url: api.sysDept.getDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        this.orgOptions = []
        res.data.data.forEach(item => {
          let temp = {
            value: item.id,
            label: item.name,
          }
          if (item.hasChild) {
            temp.children = []
            item.child.forEach(item1 => {
              temp.children.push({
                value: item1.deptId,
                label: item1.name
              })
            })
          }
          this.orgOptions.push(temp)
        })
      })
    },

    updateHandleMatterName() {
      const selectedOption = this.sysDictItemList.find(item => item.value === this.formData.handleMatter);
      if (selectedOption) {
        this.formData.handleMatterName = selectedOption.label;
      } else {
        this.formData.handleMatterName = null;
      }
    },

    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      // 物流公司
      loadDictData(dictType.handleMatter).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.sysDictItemList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },

    // 工单弹框选中
    orderCommit(data) {
      this.formData.orderId = data.orderId
      this.formData.orderNo = data.orderNo
    },

    saveData() {
      this.formData.fileList = this.fileList;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = api.soOrderHandle.saveOrUpdate
            this.$http({
              url: url,
              method: 'post',
              data: this.formData,
              isLoading: true,
            }).then(response => {
              this.$message.success("保存成功！");
              this.reload()
              this.$mask.close()

            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
;
          });
        }
      });
    },

    handle(){
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('确认提交处理结果吗？').then(() => {
            var url = api.soOrderHandle.handle
            this.$http({
              url: url,
              method: 'post',
              data: this.formData,
              isLoading: true,
            }).then(response => {
              this.$message.success("处理完成！");
              this.reload()
            });
          });
        }
      });
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.soOrderHandle.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if(data.handleStat==1){
            this.stat1=false
          }else {
            this.stat1=true
          }
          this.formData = data
          if(data.fileUrl1!=null&&data.fileUrl1!=""&&data.fileName1!=null&&data.fileName1!="") {
            this.fileList.push({url: data.fileUrl1,name:data.fileName1})
          }
          if(data.fileUrl2!=null&&data.fileUrl2!=""&&data.fileName2!=null&&data.fileName2!="") {
            this.fileList.push({url: data.fileUrl2,name:data.fileName2})
          }
          if(data.fileUrl3!=null&&data.fileUrl3!=""&&data.fileName3!=null&&data.fileName3!="") {
            this.fileList.push({url: data.fileUrl3,name:data.fileName3})
          }
          this.orgValue = data.orgId
          this.formData.replyTime = new Date()
          this.validateTime(0)
          this.formData.replyerName = store.getters.userInfo.username
          this.formData.replyerId = store.getters.userInfo.id
        })
      }
    },

    showSitePopType(type){
      this.showSitePop = true;
      this.type = type;
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList = echoFileFormat(res.data.url)
    },


    handleClick(tab, event) {
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn = false;
    },

    // 上传成功
    handleSuccess4(res, file, picIndex) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn4 = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      Vue.set(this.tenant.businessPhoto,)

    },
    handleRemove4(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn4 = false;
    },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}



// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}


// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}
// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  width: 12vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}
#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
.papers {
  margin-left: 20px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 30px;
  }

}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  position: absolute !important;
  bottom: -57px;
}
</style>
